import QualificationQuestions from './QualificationQuestions.page';

export default QualificationQuestions;
